// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__HDXh9","section":"styles_section__2XxCm","stars":"styles_stars__10hHX","count":"styles_count__1HlrK"};